var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company__item",class:{
    'company__item--selected': _vm.isSelectedCompany(_vm.company.id),
  },on:{"click":function($event){return _vm.setSelectedCompany(_vm.company)}}},[_c('div',{staticClass:"item__logo",class:_vm.isSelectedCompany(_vm.company.id) ? 'item__logo--selected' : 'item__logo--unselected'},[_c('img',{staticClass:"company__item--logo",attrs:{"src":_vm.company.foto_perfil_totem,"alt":_vm.company.nome},on:{"error":_vm.handleImgError}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }